export enum AuthRequestType {
  AuthenticateAndUnlock = 0,
  Unlock = 1,
}
